import { writeBatch } from 'firebase/firestore'
import { useCallback, useContext, useMemo } from 'react'
import { ParentContext } from '../ParentContext';
import { createRefPath_event } from 'global/firestoreData/appData/appRefPaths';
import { logBatch } from 'global/cnr/reducers/reducerHelpers/logging';
import { textInputRule } from '@tiptap/core';

const _allowDuplicateUpdate = textInputRule

export const useDuplicates = ({ appDataDocuments, appUserCollection }) => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { app_state, paps_state } = states
  const { mainDb } = app_state ?? {}
  const { pathViews } = paps_state ?? {}
  const { database_fns } = fns

  const getDuplicates = () => {
    const _dups = {}
    const _appUserDocument = appDataDocuments?.[appUserCollection]
    if (_appUserDocument) {
      const _grp = _.groupBy(_appUserDocument, (item) =>
        `${item.firstName}_${item.lastName}`
      );
      _.forEach(_grp, (items) => {
        if (_.size(items) > 1) {
          const firstItem = items[0]
          if (!_dups[`${firstItem.firstName}_${firstItem.lastName}`]) { _dups[`${firstItem.firstName}_${firstItem.lastName}`] = [] }
          _.forEach(items, i => {
            _dups[`${firstItem.firstName}_${firstItem.lastName}`].push(i)
          })
        }
      })
    }
    console.log('_dups', _dups)

    return _dups
  }

  const mergeDuplicates = () => {
    const _appUserDocument = appDataDocuments?.[appUserCollection];
    if (!_appUserDocument) return appDataDocuments;

    const _grp = _.groupBy(_appUserDocument, (item) =>
      `${item.firstName}_${item.lastName}`
    );

    _.forEach(_grp, (items) => {
      if (_.size(items) > 1) {
        const primary = items[0];

        const merged = _.reduce(
          items,
          (acc, item) => {
            return _.mergeWith(acc, item, (objValue, srcValue, key) => {
              // 🚫 NEVER merge _itemStatusType
              if (key === '_itemStatusType') {
                return objValue;
              }

              // Arrays → union
              if (_.isArray(objValue)) {
                return _.union(objValue, srcValue);
              }

              // Fill empty values
              if (_.isNil(objValue) || objValue === '') {
                return srcValue;
              }

              return objValue;
            });
          },
          _.cloneDeep(primary) // 🧠 avoid mutating during merge
        );

        // Apply merged result back to primary
        _.assign(primary, merged);

        // 🔥 Always remove _itemStatusType from primary
        delete primary._itemStatusType;

        // Ensure primary stays active
        // primary._itemStatusType = primary._itemStatusType || 'active';

        // Mark ONLY the others inactive
        _.forEach(items.slice(1), (item) => {
          if (item !== primary) {
            item._itemStatusType = 'inactive';
          }
        });
      }
    });

    return getDuplicates(appDataDocuments, appUserCollection)
  };

  const updateDuplicates = useCallback((duplicates) => {
    const batch = writeBatch(mainDb);
    const docsToUpdate = {};
    _.forEach(duplicates, dupItem => {
      _.forEach(dupItem, dup => {
        const { _itemKey } = dup
        const refPath = createRefPath_event(pathViews, [appUserCollection, _itemKey]);
        database_fns.set_doc(refPath, dup, true, false, batch)
        docsToUpdate[_itemKey] = dup;
      })
    })
    const refPath_docs = createRefPath_event(pathViews, ['_documents', appUserCollection]);
    //refPath, data, merge, dispatch, batch, altDb
    database_fns.set_doc(refPath_docs, docsToUpdate, true, null, batch);
    logBatch(batch)
    if (_allowDuplicateUpdate) {
      batch.commit()
    }
  }, []);

  // krizpz2@yahoo.com

  const duplicates = useMemo(() => {
    return mergeDuplicates()
  }, [appDataDocuments, appUserCollection])

  return { duplicates, updateDuplicates }

}
